import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const CompanySection = Loadable(lazy(() => import('./CompanySection')));
const CompanyList = Loadable(lazy(() => import('./CompanyList')));
const ProductEditList = Loadable(
	lazy(() => import('../../form/EditProductForm'))
);

const CompanyRoutes = [
	{
		path: '/company/add',
		element: <CompanySection />,
		auth: authRoles.admin,
	},
	{
		path: '/company/list',
		element: <CompanyList />,
		auth: authRoles.admin,
	},
	{
		path: '/product/edit',
		element: <ProductEditList />,
		auth: authRoles.admin,
	},
];

export default CompanyRoutes;
